import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dis",
  "use": "icon-dis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dis\"><defs><style type=\"text/css\"></style></defs><path d=\"M213.333333 947.2V725.333333H42.666667V128h768v597.333333H467.2L213.333333 947.2zM128 640h170.666667v119.466667l134.4-119.466667H725.333333V213.333333H128v426.666667z\" fill=\"\" p-id=\"5422\" /><path d=\"M981.333333 896H554.666667v-85.333333h341.333333V512h-85.333333v-85.333333h170.666666z\" fill=\"#29ABE2\" p-id=\"5423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dis.svg
// module id = S01t
// module chunks = 50